
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
ol,
ul{
  list-style:none;

  margin:var(--sic-breadcrumb--default--margin);

  margin:var(--sic-breadcrumb--margin, var(--sic-breadcrumb--default--margin));

  padding:var(--sic-breadcrumb--default--padding);

  padding:var(
    --sic-breadcrumb--padding,
    var(--sic-breadcrumb--default--padding)
  );

  display:var(--sic-breadcrumb--default--display);

  display:var(
    --sic-breadcrumb----sic-breadcrumb--default--display,
    var(--sic-breadcrumb--default--display)
  );

  flex-direction:var(--sic-breadcrumb--default--flex-direction);

  flex-direction:var(
    --sic-breadcrumb--flex-direction,
    var(--sic-breadcrumb--default--flex-direction)
  );

  flex-wrap:var(--sic-breadcrumb--default--flex-wrap);

  flex-wrap:var(
    --sic-breadcrumb--flex-wrap,
    var(--sic-breadcrumb--default--flex-wrap)
  );

  font-family:var(--sic-breadcrumb--default--font-family);

  font-family:var(
    --sic-breadcrumb--font-family,
    var(--sic-breadcrumb--default--font-family)
  );

  font-size:var(--sic-breadcrumb--default--font-size);

  font-size:var(
    --sic-breadcrumb--font-size,
    var(--sic-breadcrumb--default--font-size)
  );

  font-weight:var(--sic-breadcrumb--default--font-weight);

  font-weight:var(
    --sic-breadcrumb--font-weight,
    var(--sic-breadcrumb--default--font-weight)
  );

  line-height:var(--sic-breadcrumb--default--line-height);

  line-height:var(
    --sic-breadcrumb--line-height,
    var(--sic-breadcrumb--default--line-height)
  );

  gap:var(--sic-breadcrumb--default--gap);

  gap:var(--sic-breadcrumb--gap, var(--sic-breadcrumb--default--gap));
}

li{
  display:flex;
  flex-direction:row;
  align-items:center;
  position:relative;
  color:var(--sic-breadcrumb-item--default--color);
  color:var(
    --sic-breadcrumb--override--text-color,
    var(
      --sic-breadcrumb-item--color,
      var(--sic-breadcrumb-item--default--color)
    )
  );
  padding:var(--sic-breadcrumb-item--default--padding);
  padding:var(
    --sic-breadcrumb-item--padding,
    var(--sic-breadcrumb-item--default--padding)
  );

  margin:var(--sic-breadcrumb-item--default--margin);

  margin:var(
    --sic-breadcrumb-item--margin,
    var(--sic-breadcrumb-item--default--margin)
  );
}

li:not(:first-of-type)::before{
  content:'';
  display:flex;
  margin-right:var(--spacing-03);
  height:1em;
  width:1px;
  background:currentColor;
  transform:rotate(23deg);
}

a{
  text-decoration:none;
  display:inline-flex;
  align-items:center;

  padding:var(--sic-breadcrumb-item-link--default--padding);

  padding:var(
    --sic-breadcrumb-item-link--padding,
    var(--sic-breadcrumb-item-link--default--padding)
  );
  margin:var(--sic-breadcrumb-item-link--default--margin);
  margin:var(
    --sic-breadcrumb-item-link--margin,
    var(--sic-breadcrumb-item-link--default--margin)
  );

  color:var(--sic-breadcrumb-item-link--default--color);

  color:var(
    --sic-breadcrumb--override--text-color,
    var(
      --sic-breadcrumb-item-link--color,
      var(--sic-breadcrumb-item-link--default--color)
    )
  );

  background:var(--sic-breadcrumb-item-link--default--background);

  background:var(
    --sic-breadcrumb-item-link--background,
    var(--sic-breadcrumb-item-link--default--background)
  );

  font-family:var(--sic-breadcrumb-item-link--default--font-family);

  font-family:var(
    --sic-breadcrumb-item-link--font-family,
    var(--sic-breadcrumb-item-link--default--font-family)
  );

  font-size:var(--sic-breadcrumb-item-link--default--font-size);

  font-size:var(
    --sic-breadcrumb-item-link--font-size,
    var(--sic-breadcrumb-item-link--default--font-size)
  );

  font-weight:var(--sic-breadcrumb-item-link--default--font-weight);

  font-weight:var(
    --sic-breadcrumb-item-link--font-weight,
    var(--sic-breadcrumb-item-link--default--font-weight)
  );

  line-height:var(--sic-breadcrumb-item-link--default--line-height);

  line-height:var(
    --sic-breadcrumb-item-link--line-height,
    var(--sic-breadcrumb-item-link--default--line-height)
  );
}

a:hover{
    text-decoration:underline;
  }

a:focus,
  a:focus-visible{
    outline:solid 3px var(--sic-breadcrumb--default--icon-color);
    outline:solid 3px var(
        --sic-breadcrumb--icon-color,
        var(--sic-breadcrumb--default--icon-color)
      );
    border-radius:var(--border-radius-button-default);
    outline-offset:var(--spacing-px);
  }

@media (min-width: 1024px){

a:focus,
  a:focus-visible{
      outline:solid 3px var(--sic-breadcrumb--default--icon-color);
      outline:solid 3px var(
          --sic-breadcrumb--override--icon-color,
          var(
            --sic-breadcrumb--icon-color,
            var(--sic-breadcrumb--default--icon-color)
          )
        )
  }
    }

.separator{
  margin-left:var(--sic-breadcrumb--default--gap);
  margin-left:var(--sic-breadcrumb--gap, var(--sic-breadcrumb--default--gap));
}

.previous-link{
  display:flex;
  flex-direction:row;
  align-items:center;
}

sic-icon{
  margin-right:var(--sic-breadcrumb--default--gap);
  margin-right:var(--sic-breadcrumb--gap, var(--sic-breadcrumb--default--gap));
  color:var(--sic-breadcrumb--default--icon-color);
  color:var(
    --sic-breadcrumb--override--icon-color,
    var(
      --sic-breadcrumb--icon-color,
      var(--sic-breadcrumb--default--icon-color)
    )
  );
  fill:var(--sic-breadcrumb--default--icon-color);
  fill:var(
    --sic-breadcrumb--override--icon-color,
    var(
      --sic-breadcrumb--icon-color,
      var(--sic-breadcrumb--default--icon-color)
    )
  );
}

.sic-breadcrumb-container{
  background-color:var(--sic-breadcrumb--default--background-color);
  background-color:var(
    --sic-breadcrumb--override--background-color,
    var(
      --sic-breadcrumb--background-color,
      var(--sic-breadcrumb--default--background-color)
    )
  );
  color:inherit;
  color:var(--sic-breadcrumb--override--text-color, inherit);

  border-top:solid 1px var(--sic-breadcrumb--override--background-color);

  border-top:solid 1px var(
      --sic-breadcrumb--override--top-border-color,
      var(--sic-breadcrumb--override--background-color)
    );
}

.sic-breadcrumb-container.is-mobile{
    --sic-breadcrumb--padding:0;
    background-color:transparent;
    color:inherit;
  }

.sic-breadcrumb-container.is-mobile a{
      color:var(--sic-breadcrumb-item-link--default--color);
      color:var(
        --sic-breadcrumb-item-link--color,
        var(--sic-breadcrumb-item-link--default--color)
      );
    }

.sic-breadcrumb-container.is-mobile{
    border-top-color:transparent;
}

.sic-breadcrumb-container.is-mobile sic-icon{
      color:var(--sic-breadcrumb--default--icon-color);
      color:var(
        --sic-breadcrumb--icon-color,
        var(--sic-breadcrumb--default--icon-color)
      );
      fill:var(--sic-breadcrumb--default--icon-color);
      fill:var(
        --sic-breadcrumb--icon-color,
        var(--sic-breadcrumb--default--icon-color)
      );
    }
`;